import {clsx} from 'clsx';
import type {UseComboboxGetToggleButtonPropsReturnValue} from 'downshift';
import {memo} from 'react';

import type {Size} from '#theme';
import type {Icons} from '#ui/atoms/icon/icons.js';
import {Icon} from '#ui/atoms/icon/index.js';

import * as styles from './style.module.scss';

type ToggleMenuButtonProps = {
  isOpen: boolean;
  size?: Size;
  icon?: Icons;
  className?: string;
  ariaLabel?: string;
} & UseComboboxGetToggleButtonPropsReturnValue;

const ToggleMenuButton = memo(function ToggleMenuButton({
  isOpen,
  size = 12,
  icon = 'down',
  className,
  ariaLabel = 'toggle menu',
  ...props
}: ToggleMenuButtonProps) {
  return (
    <button
      {...props}
      aria-label={ariaLabel}
      type="button"
      className={clsx(
        styles.toggleMenuButton,
        {
          [styles.toggleMenuButtonOpen]: isOpen,
        },
        className
      )}
    >
      <Icon name={icon} size={size} />
    </button>
  );
});

export {ToggleMenuButton};
